import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const getSasUrl = (blobName: string, containerType: BlobContainerType): AxiosPromise<string> => {
  return api.get<string>(endpoints.BLOBS.GET_SAS_URL(blobName, containerType));
};

export const blobsApi = {
  getSasUrl,
};

export const BLOB_CONTAINER = {
  IMAGES_UPLOAD: 0,
  INVOICES: 1,
  DOCUMENTS: 2,
  COURSE_RESOURCES: 3,
  DOCUMENT_TEMPLATES: 4,
  EXAMS: 5,
} as const;

export type BlobContainerType = (typeof BLOB_CONTAINER)[keyof typeof BLOB_CONTAINER];

export type BlobContainerTypeName = keyof typeof BLOB_CONTAINER;
